
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"103","height":"100","viewBox":"0 0 103 100","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51.29 0C23.3 0 .624 22.675.624 50.664c0 24.004 16.698 44.118 39.09 49.336-17.838-9.488-25.048-31.31-16.51-49.62 1.424 7.4 6.263 13.757 13.094 16.982C27.19 45.92 33.927 20.683 52.902 6.736c-3.7 12.714 1.992 24.383 14.232 33.207C81.175 50 81.744 70.588 69.41 81.69c5.028-1.139 9.582-3.985 12.903-7.97C80.227 84.63 73.395 94.402 62.959 100c22.39-5.218 39.089-25.332 39.089-49.336C101.953 22.675 79.278 0 51.289 0zm43.642 96.205c-.759 0-1.328.285-1.518.854a1.796 1.796 0 00-1.518-.854h-.284v3.7h.474v-3.32c.664 0 1.139.474 1.139 1.233v.949h.474v-.95c0-.758.474-1.233 1.139-1.233v3.321h.474v-3.7h-.38zm-6.641.474h.949V100h.474v-3.32h.949v-.475h-2.372v.474z"}})])
          )
        }
      }
    